<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div
    class="tw-fixed tw-inset-0 tw-z-50 tw-overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="tw-flex tw-min-h-screen tw-items-start tw-justify-center tw-px-4 tw-pb-20 tw-pt-20 tw-pt-4 tw-text-center sm:tw-block sm:tw-p-0"
    >
      <div
        class="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75 tw-transition-opacity"
        aria-hidden="true"
        @click="resetTimer"
      />

      <span
        class="tw-hidden sm:tw-inline-block sm:tw-h-screen sm:tw-align-middle"
        aria-hidden="true"
        >&#8203;</span
      >

      <div
        class="tw-relative tw-inline-block tw-transform tw-overflow-hidden tw-rounded-lg tw-bg-white tw-text-left tw-align-bottom tw-shadow-xl tw-transition-all sm:tw-my-8 sm:tw-w-full sm:tw-max-w-md sm:tw-align-middle"
      >
        <div class="tw-bg-white tw-px-4 tw-pb-4 tw-pt-5 sm:tw-p-6 sm:tw-pb-4">
          <div>
            <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-text-left">
              <p class="tw-mt-2 tw-text-gray-700">
                {{ logoutLabel }}
              </p>

              <div class="tw-mt-2">
                <p class="tw-pt-4 tw-text-center tw-font-bold tw-text-red-600">
                  {{ timeLabel }}
                </p>

                <div class="tw-flex tw-flex-row tw-gap-2">
                  <c-button
                    class="tw-flex-1"
                    label="Ingelogd blijven"
                    @click="resetTimer"
                  />

                  <c-button
                    class="tw-flex-1"
                    outline
                    label="Uitloggen"
                    @click="logout"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  MAX_NO_ACTIVITY_IN_MS,
  WARNING_TIME_IN_MS,
} from "composables/useInteractionTimer";
import { computed } from "vue";

const emit = defineEmits(["reset-timer", "logout"]);

// Props
const props = defineProps({
  timer: {
    type: [Array, null],
    required: true,
  },
});

const msToMinutes = (ms) => {
  return Math.floor(ms / 60000);
};

const logoutLabel = computed(() => {
  return `Omdat je ${msToMinutes(MAX_NO_ACTIVITY_IN_MS - WARNING_TIME_IN_MS)} minuten niets hebt gedaan, word je over ${msToMinutes(WARNING_TIME_IN_MS)} minuten automatisch uitgelogd.`;
});

const timeLabel = computed(() => {
  const { timer = [] } = props || {};

  if (!timer || timer.length === 0) {
    return "Je sessie verloopt over 0:00 minuten.";
  }

  const [minutes = 0, seconds = 0] = timer;

  return `Je sessie verloopt over ${minutes}:${seconds.toString().padStart(2, "0")} minuten.`;
});

// Methods
const logout = () => {
  emit("logout");
};

const resetTimer = () => {
  emit("reset-timer");
};
</script>
